import { BrokerTeam } from '@insurance/api/requests'
import { Text } from '@shared/components'
import { Badge, Dropdown, Tag } from 'antd'
import { BadgeProps } from 'antd/lib'
import { useTheme } from 'antd-style'

import { useTranslation } from 'react-i18next'

type Props = {
  teams?: BrokerTeam[]
} & BadgeProps

export const AgentTeams = ({ teams, ...props }: Props) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const teamsItems =
    teams
      ?.filter((team) => team.id !== teams?.[0]?.id)
      ?.map((team) => ({
        key: String(team.id),
        label: <Text>{team.name}</Text>
      })) || []

  const extraTeamsCount = teams && teams.length > 1 ? teams.length - 1 : null

  if (!teams) return '-'

  return (
    <Dropdown
      menu={{
        onClick: (e) => e.domEvent.stopPropagation(),
        items: [
          ...(extraTeamsCount
            ? [
                {
                  key: 'title',
                  type: 'group' as const,
                  label: (
                    <Text type="secondary" weight={500}>
                      {t('other_teams')}
                    </Text>
                  )
                }
              ]
            : []),
          ...teamsItems
        ]
      }}
      trigger={['hover']}
    >
      <Badge
        {...props}
        color={theme.colorPrimary}
        count={extraTeamsCount && `+${extraTeamsCount}`}
      >
        <Tag>{teams?.[0]?.name}</Tag>
      </Badge>
    </Dropdown>
  )
}
